import React from "react";
// icons
import { MdOutlineDarkMode, MdOutlineLightMode } from "react-icons/md";
// styled components
import { ModeStyle } from "./darkModeStyle";

const DarkMode = ({ theme, themeToggler }) => {
  // if theme is light dark icon and if theme is dark light icon

  return (
    <ModeStyle
      border={theme === "light" ? "#360069" : "#ff9f0f"}
      onClick={themeToggler}
    >
      {theme === "light" ? (
        <MdOutlineDarkMode size={15} color="#360069" />
      ) : (
        <MdOutlineLightMode size={15} color="#ff9f0f" />
      )}
    </ModeStyle>
  );
};

export default DarkMode;
